import {SLQueryParamConfig, slQueryParamConfigMap} from '#/contexts/query-params-provider';
import {ExchangeRoute} from '#/routes/exchange/exchange-route';
import qs from 'query-string';
import {DecodedValueMap, encodeQueryParams} from 'use-query-params';

type AppRoute =
  | ExchangeRoute.HOME
  | ExchangeRoute.MAP
  | ExchangeRoute.PORTFOLIO
  | `${ExchangeRoute.PORTFOLIO}${string}`;

export const getExchangeRouteWithQueryParams = (
  route: AppRoute,
  queryParams: Partial<DecodedValueMap<SLQueryParamConfig>>,
): string => {
  const encodedQuery = encodeQueryParams(slQueryParamConfigMap, queryParams);
  const queryString = `?${qs.stringify(encodedQuery)}`;
  return `${route}${queryString}`;
};
